import avoyaLeadServiceFactory from "@/factories/lead-service/avoya-lead-service-factory";
import {LeadFormDataTypes, LeadType} from "@/types/leads/lead-forms";
import {useState} from "react";
import useGaSessionInfo from "@/hooks/ga-session/use-ga-session";

interface UseLeadSubmitProps {
  locale: string;
  sourceUrl: string;
  leadType: Exclude<LeadType, "RAB">;
}

const useLeadSubmit = <T extends LeadFormDataTypes>({
  locale,
  sourceUrl,
  leadType
}: UseLeadSubmitProps) => {
  const [serverError, setServerError] = useState<boolean>(false);

  const gaData = useGaSessionInfo();

  const onSubmit = async (data: T) => {
    try {
      const avoyaApi = "/api/avoya-service";
      const avoyaServiceRequest = avoyaLeadServiceFactory(
        data,
        sourceUrl,
        leadType,
        false,
        locale,
        undefined,
        gaData
      );

      const [avoyaResponse] = await Promise.all([
        fetch(avoyaApi, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(avoyaServiceRequest)
        }),
        fetch("/api/lead-service?datasource=legacy", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(avoyaServiceRequest)
        })
      ]);

      if (!avoyaResponse.ok) {
        setServerError(true);
      }
    } catch (e) {
      setServerError(true);
      console.error("Error posting data:", e);
    }
  };

  return { onSubmit, serverError };
};

export default useLeadSubmit;